module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row-fluid privacy container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "headline"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('FAQ.bloc1.title')))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-group acc-v1 margin-bottom-40",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapse1",
      "ng-click": "tabClick($event)"
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('FAQ.bloc1.q1')) + "\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('FAQ.bloc1.a1')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapse2",
      "ng-click": "tabClick($event)"
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('FAQ.bloc1.q2')) + "\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse ",
    attrs: {
      "id": "collapse2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('FAQ.bloc1.a2')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapse3",
      "ng-click": "tabClick($event)"
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('FAQ.bloc1.q3')) + "\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse ",
    attrs: {
      "id": "collapse3"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('FAQ.bloc1.a3')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapse4",
      "ng-click": "tabClick($event)"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t('FAQ.bloc1.q4')) + "\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse ",
    attrs: {
      "id": "collapse4"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('FAQ.bloc1.a4')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapse5",
      "ng-click": "tabClick($event)"
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('FAQ.bloc1.q5')) + "\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse ",
    attrs: {
      "id": "collapse5"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('FAQ.bloc1.a5')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapse6",
      "ng-click": "tabClick($event)"
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('FAQ.bloc1.q6')) + "\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse ",
    attrs: {
      "id": "collapse6"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('FAQ.bloc1.a6')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapse7",
      "ng-click": "tabClick($event)"
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('FAQ.bloc1.q7')) + "\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse ",
    attrs: {
      "id": "collapse7"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('FAQ.bloc1.a7')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapse8",
      "ng-click": "tabClick($event)"
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('FAQ.bloc1.q8')) + "\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse ",
    attrs: {
      "id": "collapse8"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('FAQ.bloc1.a8')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "accordion-toggle",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapse9",
      "ng-click": "tabClick($event)"
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('FAQ.bloc1.q9')) + "\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse ",
    attrs: {
      "id": "collapse9"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('FAQ.bloc1.a9'))), _c('br'), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.$t('FAQ.bloc1.mood-blue')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('FAQ.bloc1.mood-green')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('FAQ.bloc1.mood-red')))])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row centered"
  }, [_c('h6', [_c('i', [_vm._v(_vm._s(_vm.$t('FAQ.bloc1.help')))])])])]), _vm._v(" "), _c('p', [_vm._v(" ")]), _c('br'), _c('br'), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "banner2"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [_c('div', {
    staticClass: "banner__caption2"
  }, [_c('h1', {
    attrs: {
      "nowrap": ""
    }
  }, [_vm._v("FAQ")]), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-229abea6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FAQ.vue
// module id = 61
// module chunks = 0